export default __webpack_public_path__ + "static/media/location-on-black-18-dp.1153167b.svg";